import React, { useEffect, useState } from 'react'
import UserLayout from '../../components/layouts/UserLayout'
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ERROR } from '../../store/types';
import CheckBadgeIcon from '../../components/elements/icons/CheckBadgeIcon';
import Loader from '../../components/elements/Loader';
import Countdown from '../../components/elements/Countdown';
import CloseIcon from '../../components/elements/icons/CloseIcon';

const VerifyPayment = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [paymentVerified, setPaymentVerified] = useState(false);
    const [counted, setCounted] = useState(true);
    const [searchParams] = useSearchParams()
    const [paymentCancelled, setPaymentCancelled] = useState(false)
    
    useEffect(() => {
        const confirmPayment = async () => {
            try {
              const headers = {
                'Content-Type': 'application/json'
              }
      
              const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/payments/verify-payment/${searchParams.get("transaction_id")}`, { headers })            
              console.log(response.data.data)
              setPaymentVerified(true)
              setCounted(false)
              setTimeout(() => {
                if(searchParams.get("admission")) {
                    navigate(`/user/applications/new-application/${searchParams.get("admission")}`)
                }

                if(searchParams.get("admission-offer")) {
                    navigate(`/user/admission-offers/${response.data.data.student.admissionOffer}/medicals`)
                }

                if(searchParams.get("invoice-assignment")) {
                    navigate(`/user/students/student/${searchParams.get("student")}?activeTab=invoices`)
                }

              }, 5000);
      
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setPaymentVerified(false)
            }
          }
          if(searchParams.get("status") !== 'cancelled'){
            confirmPayment()
          } else {
            setPaymentCancelled(true)
          }
          return () => {
            
          };
        
    }, [dispatch, navigate, searchParams]);
    return (
        <UserLayout>
            <div className='w-full bg-vcm-light-purple bg-opacity-10 min-h-screen h-inherit py-12'>
                <div className="w-4/12 mx-auto rounded-[8px] bg-white p-8 transition duration-200">
                    <h1 className="font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

                    <div className='border-b w-full border-gray-300 mt-8 mb-4' />

                    {!paymentCancelled && <>
                        {!paymentVerified ? 
                        <div className='flex flex-col items-center justify-center'>
                            <Loader />
                            <p className="text-sm text-center w-10/12">Hold on a moment, we're verifying your payment.
                            </p> 
                        </div>
                        :
                        <>
                            <div className='flex items-center justify-center text-center'>
                                <CheckBadgeIcon className={`text-purple-500 w-10 h-10 mb-4`} />
                            </div>
                            <h1 className="font-thin text-xs text-center w-full text-primary mb-2 text-opacity-80 tracking-[0.2em] uppercase">thank you</h1>
                            <p className='w-full text-center text-sm'>Your payment was successful!</p>

                        </>}
                    </>}

                    {paymentCancelled && <>
                        <div className='flex items-center justify-center text-center'>
                            <CloseIcon className={`text-red-600 w-10 h-10 mb-4`} />
                        </div>
                        <h1 className="font-thin text-xs text-center w-full text-red-600 mb-2 text-opacity-80 tracking-[0.2em] uppercase">Payment Cancelled</h1>
                        <p className='w-full text-center text-sm'>Your payment was cancelled!</p>

                    </>}

                    <div className='w-full text-center'>
                    {counted 
                        ? 
                            <p></p>
                        :
                        <>
                            {searchParams.get("admission") && <p className='py-2 text-gray-400 text-xs mt-2'>Redirecting you to the application page in <Countdown seconds={5} className='inline text-green-500 font-medium' countdownComplete={()=>{setCounted(true)}} /> seconds
                            </p>}
                            {searchParams.get("admission-offer") && <p className='py-2 text-gray-400 text-xs mt-2'>Redirecting you to the student's profile in <Countdown seconds={5} className='inline text-green-500 font-medium' countdownComplete={()=>{setCounted(true)}} /> seconds
                            </p>}
                        </>
                    }
                    </div>

                </div>
            </div>
        </UserLayout>
    )
}

export default VerifyPayment